import { AdvertiserFilterOption } from '@features/campaigns/list/services/listAdvertisers';

import styles from './AdvertiserFilterOptionTemplate.module.scss';

function AdvertiserFilterOptionTemplate(option: AdvertiserFilterOption) {
  return (
    <span className={styles.optionLabel} title={option.label}>
      {option.label}
    </span>
  );
}

export default AdvertiserFilterOptionTemplate;
